interface VoicefillLogoProps {
  iconColor?: string;
  bottomBarColor?: string;
  size?: number;
}

export const VoicefillLogo = ({
  iconColor = 'var(--primary-darker)',
  bottomBarColor = 'var(--primary-darker)',
  size = 38,
}: VoicefillLogoProps) => {
  const height = (size / 38) * 52; // Maintain aspect ratio

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 38 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9736 3.45366C10.9736 1.54626 12.5198 0 14.4272 0H22.92C24.8274 0 26.3736 1.54626 26.3736 3.45366C26.3736 5.36107 24.8274 6.90733 22.92 6.90733H14.4272C12.5198 6.90733 10.9736 5.36107 10.9736 3.45366Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.51305 14.5055C3.51305 12.598 4.76847 11.0516 6.31711 11.0516H31.0314C32.58 11.0516 33.8355 12.598 33.8355 14.5055C33.8355 16.4129 32.58 17.9593 31.0314 17.9593H6.31711C4.76847 17.9593 3.51305 16.4129 3.51305 14.5055Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.51305 25.5573C3.51305 23.6498 4.76847 22.1035 6.31711 22.1035H31.0314C32.58 22.1035 33.8355 23.6498 33.8355 25.5573C33.8355 27.4648 32.58 29.0111 31.0314 29.0111H6.31711C4.76847 29.0111 3.51305 27.4648 3.51305 25.5573Z"
        fill={iconColor}
      />
      <rect
        x="13.7249"
        y="33.1558"
        width="9.8983"
        height="6.90178"
        rx="3.45089"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 47.6582C0 45.7507 1.54633 44.2043 3.45382 44.2043H33.8951C35.8025 44.2043 37.3489 45.7507 37.3489 47.6582C37.3489 49.5657 35.8025 51.112 33.8951 51.112H3.45382C1.54633 51.112 0 49.5657 0 47.6582Z"
        fill={bottomBarColor}
      />
    </svg>
  );
};
